
import 'react-quill/dist/quill.snow.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './Router';
import { theme } from './application/styles/theme';
import { AuthProvider } from './application/context/AuthContext';
import { ToastContainer } from './shared/shell/Toast/Toast';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TidioChat } from './shared/shell/TidioChat/TidioChat';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: true
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
            <TidioChat />
          </AuthProvider>
          <ToastContainer />
        </ThemeProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App; 